import DashboardWithOpenSideNav from "components/Layout/DashboardWithOpenSideNav/DashboardWithOpenSideNav";
import { replenishmentDrawerElements } from "components/ReplenishmentDashboard/data";
import ReplenishmentDashboard from "components/ReplenishmentDashboard/ReplenishmentDashboard";
import { Route } from "react-router-dom";

export const generateReplenishmentRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types) {
		const defaultRoute = Object.values(service.types)[0];
		return (
			<Route key={service.key} path={service.key}>
				<Route
					index
					element={
						<DashboardWithOpenSideNav
							drawerList={replenishmentDrawerElements}
							navSpace={1}
							service={defaultRoute}
							pathName={defaultRoute.key}
							rootPath={rootPath}
						/>
					}
				/>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateReplenishmentRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	} else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardWithOpenSideNav
						drawerList={replenishmentDrawerElements}
						navSpace={1}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
					/>
				}>
				<Route index element={<ReplenishmentDashboard />} />
			</Route>
		);
};
